import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';

class VisualSlides {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('[data-js="visual-slide"]');
    this.dom.slides = this.dom.slider.querySelectorAll('.splide__slide');

    this.dom.sliderText = this.dom.el.querySelector('[data-js="visual-slide-text"]');
    this.dom.sliderLeft = this.dom.el.querySelector('[data-js="visual-slide-left"]');
    this.dom.sliderRight = this.dom.el.querySelector('[data-js="visual-slide-right"]');

    this.dom.progress = this.dom.el.querySelector('[data-js="progress"]');
    this.dom.progressCurrent = this.dom.el.querySelector('[data-js="progress-current"]');
    this.dom.progressTotal = this.dom.el.querySelector('[data-js="progress-total"]');
    this.dom.progressCircle = this.dom.el.querySelector('[data-js="progress-circle"]');
    this.dom.progressBase = this.dom.el.querySelector('[data-js="progress-base"]');
    this.dom.progressAnimation = this.dom.el.querySelector('[data-js="progress-animation"]');

    this.mql = window.matchMedia('screen and (min-width: 768px)');
    
    this.checkBreakPoint = this.checkBreakPoint.bind(this);
    this.resizeEvent = this.resizeEvent.bind(this);
    this.nextSlide = this.nextSlide.bind(this);
    this.mountedEvent = this.mountedEvent.bind(this);

    this.progress = true;
    this.defaultWidth = null;

    this.slider = null;
    this.textSlider = null;
    this.textSlider = null;
    this.optionSP = {
      // autoplay: false,
      type: 'fade',
      rewind: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      interval: 4000,
      speed: 2400,
      arrows: false,
      pagination: false,
    };
    this.option = {
      // autoplay: true,
      type: 'loop',
      // rewind: true,
      // perPage: 1,
      pauseOnHover: false,
      pauseOnFocus: false,
      interval: 4000,
      speed: 2400,
      drag: false,
      arrows: false,
      pagination: false,
      // padding: `${160 / 1440 * 100}%`,
    };
    this.optionPC = Object.assign({}, this.option);

    this.optionPcLeft = Object.assign({}, this.option);
    this.optionPcLeft.start = this.dom.slides.length - 1;
    
    this.optionPcRight = Object.assign({}, this.option);
    this.optionPcRight.start = 1;
    
    this.optionText = {
      type: 'fade',
      perPage: 1,
      rewind: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      drag: false,
      arrows: false,
      pagination: false,
    }

    console.log(this.option)

    this.init();
  }

  init() {

    // ブレイクポイントの瞬間に発火
    this.mql.addListener(this.checkBreakPoint);
    // 初回チェック
    this.checkBreakPoint(this.mql);
  }

  setProgressScale() {
    const scale = window.innerWidth / this.defaultWidth;
    this.dom.progress.style.scale = scale;
  }
  
  resetProgressScale() {
    this.dom.progress.style.scale = 1;
  }

  resizeEvent() {

    // 768px以上のときだけ発火
    if (this.mql.matches) {
      this.setProgressScale();
    } else {
      this.resetProgressScale();
    }
  }

  nextSlide() {
    this.dom.progressAnimation.dataset.anim = 'end';
    this.progress = !this.progress;
    this.slider.go('>');

    // 768px以上のときだけ発火
    if (this.mql.matches) {
      this.leftSlider.go('>');
      this.rightSlider.go('>');
    }
  }

  mountedEvent() {
    this.dom.progressCurrent.textContent = 1;
    this.dom.progressTotal.textContent = this.dom.slides.length;

    this.dom.progressAnimation.dataset.anim = 'start';
    this.dom.progressBase.dataset.color = 'brand';
    this.dom.progressAnimation.dataset.color = 'dull';

    this.dom.progressAnimation.addEventListener('animationend', this.nextSlide);
  }

  moveEvent(_index) {
    this.dom.progressCurrent.textContent = _index;
  }

  movedEvent() {
    if (this.progress) {
      this.dom.progressBase.dataset.color = 'brand';
      this.dom.progressAnimation.dataset.color = 'dull';
    } else {
      this.dom.progressBase.dataset.color = 'dull';
      this.dom.progressAnimation.dataset.color = 'brand';
    }
    this.dom.progressAnimation.dataset.anim = 'start';
  }

  checkBreakPoint(_mql) {
		if (!_mql.matches) {
      // console.log('sp');

      if (this.slider) {
        this.slider.destroy();
        this.textSlider.destroy();
        this.leftSlider.destroy();
        this.rightSlider.destroy();
      }
      this.textSlider = new Splide(this.dom.sliderText, this.optionText);
      this.slider = new Splide(this.dom.slider, this.optionSP);

      this.slider.on('mounted', ()=>{
        this.mountedEvent();
      });
      this.slider.on('move', (newIndex, oldIndex, destIndex)=>{
        this.moveEvent(newIndex + 1);
      });
      this.slider.on('moved', (newIndex, oldIndex, destIndex)=>{
        this.movedEvent();
      });

      this.slider.sync(this.textSlider);
      this.slider.mount();
      this.textSlider.mount();

      window.removeEventListener('resize', this.resizeEvent);

      this.defaultWidth = 375;

      return;
    } else {
      // console.log('pc');

      // this.setProgressScale();

      if (this.slider) {
        this.slider.destroy();
        this.textSlider.destroy();
      }
      this.textSlider = new Splide(this.dom.sliderText, this.optionText);
      this.leftSlider = new Splide(this.dom.sliderLeft, this.optionPcLeft);
      this.rightSlider = new Splide(this.dom.sliderRight, this.optionPcRight);
      this.slider = new Splide(this.dom.slider, this.optionPC);

      this.slider.on('mounted', ()=>{
        this.mountedEvent(this.slider);
      });
      this.slider.on('move', (newIndex, oldIndex, destIndex)=>{
        this.moveEvent(newIndex + 1);
      });
      this.slider.on('moved', (newIndex, oldIndex, destIndex)=>{
        this.movedEvent();
      });

      this.slider.sync(this.textSlider);
      this.slider.mount();
      this.textSlider.mount();
      this.leftSlider.mount();
      this.rightSlider.mount();

      window.addEventListener('resize', this.resizeEvent);

      this.defaultWidth = 1440;

      return;
		}
	}
}

export default VisualSlides